import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'swiper/css/swiper.css'    
import VueAwesomeSwiper from 'vue-awesome-swiper'
import InfiniteSlideBar from 'vue-infinite-slide-bar'
// import VideoPlayer from 'vue-video-player'
import '../src/assets/css/font.css'
Vue.use(VueAwesomeSwiper)
Vue.component('InfiniteSlideBar', InfiniteSlideBar)
// Vue.use(VideoPlayer);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
